// 三方登录路由
export default [
  {
    path: "/socialiteLogin",
    name: "socialiteLogin",
    component: () => import("@/page/socialiteLogin/luqiaoecosystem.vue"),
    children: [
      {
        path: "luqiaoecosystem", // 去掉前面的斜杠
        name: "luqiaoecosystem",
        component: () => import("@/page/socialiteLogin/luqiaoecosystem.vue"),
        meta: {
          title: "",
          requiresAuth: false,
          hiddenFooter: true,
          hiddenNav: true,
          hiddenAIICon: true, // 是否隐藏AI图标
          hideHeader: true, // 是否隐藏头部
          isHideMinWidth: true, // 是否隐藏最小宽度
        },
      },
    ],
  },
];
